<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :fullscreen="openInFullscreen"
    :append-to-body="appendToBody"
  >
    <div ref="dialog"></div>
    <crud-editor
      v-if="dialogVisible && !tabbed"
      ref="editor"
      :definition="definition"
      :is-edit="isEdit"
      :is-embedded="true"
      :disabled="false"
      save-button-position="bottom"
      v-bind="{ ...$attrs, ...editorProps }"
      v-on="$listeners"
    >
      <template v-slot:footer>
        <slot />
      </template>
    </crud-editor>
    <tabbed-crud-editor
      v-if="dialogVisible && tabbed"
      ref="editor"
      :definition="definition"
      :is-edit="isEdit"
      :auto-generated-id="false"
      :is-embedded="true"
      :disabled="false"
      save-button-position="bottom"
      v-bind="{ ...$attrs, ...editorProps }"
      :get-layout="layout"
      v-on="$listeners"
    />
    &nbsp;
  </el-dialog>
</template>

<script>
import CrudEditor from '@/components/crud/Editor';
import TabbedCrudEditor from '@/components/crud/TabbedEditor';
export default {
  components: {
    CrudEditor,
    TabbedCrudEditor
  },
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: ''
    },
    openInFullscreen: {
      type: Boolean,
      default: false
    },
    editorProps: {
      type: Object,
      default: () => ({})
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    tabbed: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    definition: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: this.visible
    };
  },
  watch: {
    visible(visible) {
      this.dialogVisible = visible;
    },
    dialogVisible(dialogVisible) {
      this.$emit('update:visible', dialogVisible);
    }
  },
  methods: {
    clearForm() {
      if (this.$refs.editor) {
        this.$refs.editor.clearForm();
      }
    },
    saveForm() {
      if (this.$refs.editor) {
        this.$refs.editor.handleSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
